export const FIXING_TYPE = [
  { id: 'AT_CLOSE', displayValue: 'At Close' },
  { id: 'AT_OPEN', displayValue: 'At Open' },
  { id: 'OTHER', displayValue: 'Other' },
];
